import { FC } from "react";
import { Divider, Container, Card, CardHeader, CardMedia, CardContent, CardActions, Typography, Slide, Fade, Grid } from "@material-ui/core";
import useStyles from "./style";
import VizSensor from "react-visibility-sensor";
import Youtube from 'react-youtube';
import { useState } from "react";

type Props = {
    reverse: boolean
    title: string
    subheader: string
    description: string
    videoId: string
    iosLink?: string
    androidLink?: string
    steamLink?: string
    htmlLink?: string
}

export const PieceCard: FC<{ props: Props }> = ({ props }) => {
    const styles = useStyles();
    let [mediaActive, setMediaActive] = useState(false);
    let [descActive, setDescActive] = useState(false);

    return (
        <div>
            <Card className={styles.root} elevation={0} square>
                <div className={styles.flex}>
                    <Fade in={mediaActive} timeout={1000}>
                        <CardHeader
                            className={styles.header}
                            title={props.title}
                            subheader={props.subheader}
                        />
                    </Fade>
                    <VizSensor
                        onChange={(isVisible) => {
                            if (isVisible) {
                                setMediaActive(isVisible);
                                setDescActive(isVisible);
                            }
                        }}
                    >
                        <Fade in={mediaActive} timeout={1000}>
                            <CardMedia>
                                <Youtube
                                    videoId={props.videoId}
                                />
                            </CardMedia>
                        </Fade>
                    </VizSensor >
                    <Slide in={descActive} direction='up' timeout={2000}>
                        <div>
                            <CardDescriptions props={props} />
                        </div>
                    </Slide>
                </div>
            </Card>
            <Divider />
        </div>
    )
}


const CardDescriptions: FC<{ props: Props }> = ({ props }) => {
    const styles = useStyles();
    return (
        <div>
            <CardContent>
                <Typography className={styles.header}>
                    {props.description}
                </Typography>
            </CardContent>
            <CardContent>
                {props.iosLink ?
                    <a
                        href={props.iosLink}
                        style={{ display: "inline-block", overflow: "hidden", borderRadius: "6.5px", width: "125px", height: "41.5px" }}>
                        <img
                            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1570147200"
                            alt="Download on the App Store"
                            style={{ borderRadius: "6.5px", width: "125px", height: "41.5px", backgroundSize: "contain" }} />
                    </a>
                    : <></>
                }
                {props.androidLink ?
                    <div>Not Implemented</div>
                    : <></>
                }
                {props.steamLink ?
                    <CardContent>
                        <iframe src={props.steamLink} frameBorder="0" width="646" height="190"></iframe>
                    </CardContent>
                    : <></>
                }
                {props.htmlLink ?
                    <a href={props.htmlLink}>
                        {props.htmlLink}
                    </a>
                    : <></>
                }
            </CardContent>
        </div>
    )
}
